
<ng-container *ngIf="selectedSearch">

    <div *ngIf="hideTableHeader && selectedSearch" class="card table-header-card p-mb-0">
        <div class="p-d-flex p-ai-center p-p-3">
            <strong>{{ selectedSearch?.name }} ({{savedSearchHeading}})</strong>
        </div>
    </div>
    <div *ngIf="!hideTableHeader" class="card table-header-card p-mb-0">
        <div class="p-d-flex p-ai-center">
            <!-- Filter Component -->
            <app-filter [filterByInput]="selectedSearch.columns" [multiSelectFilter]="true"
                [dateRangeForDatetime]="dateRangeForDatetime" [showGroupByFilter]="true" [savedGroup]="groupByParams"
                [showOrderByFilter]="showOrderByFilter" [savedOrderBy]="orderByParams"
                [filterByInputValue]="filterByInputValue" [hideDateFilter]="true" [enableAPIFilter]="true"
                (onApplyFilter)="onApplyFilter($event)" (onModifyFilterOptions)="onModifyFilterOptions($event)"
                (onRemoveFilter)="onRemoveFilter($event)" (onOptionsFilter)="onOptionsFilter($event)"
                (onGroupByFilter)="onGroupByFilter($event,'group')"
                (onResetGroupByFilter)="onResetGroupByFilter('group')"
                (onOrderByFilter)="onGroupByFilter($event,'order')"
                (onResetOrderByFilter)="onResetGroupByFilter('order')"
                class="w-100">
            </app-filter>

            <div *ngIf="inPageMenu" class="p-mr-2 p-ml-auto saved-search-inpage-menu">
                <div class="btnBars">
                    <i class="pi pi-refresh" pTooltip="Refresh Table"
                    tooltipPosition="top" (click)="refreshSavedSearchQuery()"></i>
                </div>
                <div class="btnBars">
                    <i class="pi pi-upload" pTooltip="Export"
                    tooltipPosition="top" (click)="onExport()"></i>
                </div>
                <div class="btnBars" (click)="showColumnSetting()" [pTooltip]="'Column\nSetting'"
                    tooltipPosition="top">
                    <i class="pi pi-cog"></i>
                </div>
            </div>

            <div *ngIf="!inPageMenu && showMapList && !fromGroupBy" class="p-mr-2 p-ml-auto saved-search-inpage-menu" style="width: 250px;">
                <p-selectButton [options]="tableViewMode" [ngModelOptions]="{standalone: true}" (onChange)="changeViewMode($event)" [(ngModel)]="savedSearchMapView"></p-selectButton>
            </div>
        </div>
        <div *ngIf="!inPageMenu && savedSearchMapView=='map' && showMapList && !fromGroupBy">
            <div class="p-field p-grid p-mb-5">
                <div class="p-col-12">
                     <!-- Map View -->
                    <div class="map-wrapper modern-marker-map">
                        <div id="map" style="width: 100%; height: 500px;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div [class.hidden]="savedSearchMapView=='map' && !fromGroupBy">
        <p-table #savedSearchResultTable appFloatThead [floatTableRef]="savedSearchResultTable"
        floatTableClassRef="floatthead-result" [forceReflow]="isLeftTableHide" [value]="resultData"
        [columns]="selectedSearch.columns" [(rows)]="pageSize2" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="tableShowMore2" [totalRecords]="totalRecords2"
        [showJumpToPageInput]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [paginator]="true"
        [(first)]="first2" [lazy]="true" (onPage)="getSavedSearchResultByFilter($event)"
        styleClass="saved-search-result-table p-datatable-gridlines floatthead-result" [resizableColumns]="true" responsiveLayout="scroll">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngIf="fromGroupBy" style="border-right: 1px solid var(--primary-color);" pResizableColumn>Group: {{ groupByParams?.groupBy?.labelName }}</th>
                    <th *ngIf="fromGroupBy && groupByParams?.subGroupBy" style="border-right: 1px solid var(--primary-color);" pResizableColumn>Sub Group: {{ groupByParams?.subGroupBy?.labelName }}</th>
                    <ng-container *ngFor="let col of columns">
                        <th pResizableColumn
                            *ngIf="fromGroupBy && col?.isShow == true &&  col.field!=groupByParams?.groupBy?.columnName && col.field!=groupByParams?.subGroupBy?.columnName"
                            style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                            {{col.header}}
                        </th>
                        <th pResizableColumn style="border-right: 1px solid var(--primary-color);"
                            *ngIf="!fromGroupBy && col?.isShow == true">
                            {{col.header}}
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr class="parentRow" *ngIf="fromGroupBy">
                    <td colspan="30">
                        <span *ngIf="groupByParams?.groupBy?.dataType=='DateTime'">{{ groupByParams?.groupBy?.labelName }}
                            - {{rowData.GroupNameValue ? (rowData.GroupNameValue | date:'MM/dd/yyyy'): 'NA'}}</span>
                        <span *ngIf="groupByParams?.groupBy?.dataType=='Time'">{{ groupByParams?.groupBy?.labelName }}
                                - {{rowData.GroupNameValue ? (rowData.GroupNameValue | onlyTime): 'NA'}}</span>
                        <span *ngIf="!['DateTime','Time'].includes(groupByParams?.groupBy?.dataType)" [pTooltip]="rowData.GroupNameValue">{{ groupByParams?.groupBy?.labelName }}
                            - {{(rowData.GroupNameValue || rowData.GroupNameValue===false || rowData.GroupNameValue===0) ? (rowData.GroupNameValue | shorten:50) : 'NA'}}</span>
                        <span class="p-ml-1">
                            ({{rowData.GroupNameCount}})
                        </span>
                    </td>
                </tr>

                <ng-container *ngIf="fromGroupBy">
                    <ng-container *ngFor="let s of rowData.SavedSearchResult">
                        <ng-container *ngIf="groupByParams?.subGroupBy?.columnName">
                            <tr class="sub-gropup-row">
                                <td></td>
                                <td colspan="29">
                                    <span *ngIf="groupByParams?.subGroupBy?.dataType=='DateTime'">{{ groupByParams?.subGroupBy?.labelName }}
                                        - {{s?.InnerGroupNameValue ? (s.InnerGroupNameValue | date:'MM/dd/yyyy'): 'NA'}}</span>
                                    <span *ngIf="groupByParams?.subGroupBy?.dataType=='Time'">{{ groupByParams?.subGroupBy?.labelName }}
                                            - {{s?.InnerGroupNameValue ? (s.InnerGroupNameValue | onlyTime): 'NA'}}</span>
                                    <span *ngIf="!['DateTime','Time'].includes(groupByParams?.subGroupBy?.dataType)" [pTooltip]="s.InnerGroupNameValue">{{ groupByParams?.subGroupBy?.labelName }}
                                        - {{(s.InnerGroupNameValue || s.InnerGroupNameValue===false || s.InnerGroupNameValue===0) ? (s.InnerGroupNameValue | shorten:50) : 'NA'}}</span>
                                    <span class="p-ml-1">
                                        ({{s.InnerGroupNameCount}})
                                    </span>
                                </td>
                            </tr>
                            <ng-container *ngFor="let subData of s.InnerSavedSearchResult">
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <ng-container *ngTemplateOutlet="groupColumns; context: { $implicit: subData, columns: columns }"></ng-container>
                                </tr>
                            </ng-container> <!--sub group list end-->

                            <tr *ngIf="groupBySavedResults?.aggregationType!='Count'" class="sub-gropup-row">
                                <td></td>
                                <td style="white-space: break-spaces;word-break: break-all;">
                                    <strong>
                                        Sub Group {{groupBySavedResults?.aggregationType=='Sum'?'Total':groupBySavedResults?.aggregationType}}
                                    </strong>
                                </td>
                                <ng-container *ngFor="let col of columns; let i=index;">
                                    <td *ngIf="col.field!=groupByParams?.groupBy?.columnName && col.field!=groupByParams?.subGroupBy?.columnName"
                                        style="word-break: break-all;">
                                        <ng-container *ngIf="col.dataType=='currency' && groupBySavedResults?.aggregationType!='Count'">
                                            {{ s[col.field] | customNumberFormat:maximumFractionDigits | currencySymbol: null : col?.currencySymbol  }}
                                        </ng-container>
                                        <ng-container *ngIf="col.dataType=='number' && groupBySavedResults?.aggregationType!='Count'">
                                            <span *ngIf="(col?.header=='Probability' || col?.header=='Rep Confidence' || col?.formControlType=='Percentage')">
                                                {{ (s[col.field] || s[col.field]==0) ? (s[col.field] | numberToFixed)+'%' : '' }}
                                            </span>
                                            <span *ngIf="col?.header!='Probability' && col?.header!='Rep Confidence' && col?.formControlType!='Percentage'">
                                                {{ s[col.field] | numberToFixed }}
                                            </span>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>


                        </ng-container>
                        <ng-container *ngIf="!groupByParams?.subGroupBy?.columnName">
                            <tr>
                                <td></td>
                                <ng-container *ngTemplateOutlet="groupColumns; context: { $implicit: s, columns: columns }"></ng-container>
                            </tr>
                        </ng-container>
                    </ng-container> <!--group list end-->
                </ng-container>

                <tr *ngIf="fromGroupBy && groupBySavedResults?.aggregationType!='Count'" class="parentRow parentRowTotal">
                    <td style="white-space: break-spaces;word-break: break-all;">
                        <strong>
                           Group {{groupBySavedResults?.aggregationType=='Sum'?'Total':groupBySavedResults?.aggregationType}}
                        </strong>
                    </td>
                    <td *ngIf="groupByParams?.subGroupBy?.columnName"></td>
                    <ng-container *ngFor="let col of columns; let i=index;">
                        <td *ngIf="col.field!=groupByParams?.groupBy?.columnName && col.field!=groupByParams?.subGroupBy?.columnName"
                            style="word-break: break-all;">
                            <ng-container *ngIf="col.dataType=='currency' && groupBySavedResults?.aggregationType!='Count'">
                                {{ rowData[col.field] | customNumberFormat:maximumFractionDigits | currencySymbol: null : col?.currencySymbol   }}
                            </ng-container>
                            <ng-container *ngIf="col.dataType=='number' && groupBySavedResults?.aggregationType!='Count'">
                                <span *ngIf="(col?.header=='Probability' || col?.header=='Rep Confidence' || col?.formControlType=='Percentage')">
                                    {{ (rowData[col.field] || rowData[col.field]==0) ? (rowData[col.field] | numberToFixed)+'%' : '' }}
                                </span>
                                <span *ngIf="col?.header!='Probability' && col?.header!='Rep Confidence' && col?.formControlType!='Percentage'">
                                    {{ rowData[col.field] | numberToFixed }}
                                </span>
                            </ng-container>
                        </td>
                    </ng-container>
                </tr>

                <tr *ngIf="!fromGroupBy">
                    <ng-container *ngTemplateOutlet="groupColumns; context: { $implicit: rowData, columns: columns }"></ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer" let-columns>
                <tr *ngIf="!fromGroupBy && groupByParams?.aggregatedFields?.length>0">
                    <td>
                        <strong>
                            {{groupBySavedResults?.aggregationType=='Sum'?'Total':groupBySavedResults?.aggregationType}}
                        </strong>
                    </td>
                    <ng-container *ngFor="let col of columns; let i=index;">
                        <td *ngIf="i!=0">
                            <ng-container *ngIf="col.dataType=='currency' && groupBySavedResults?.aggregationType!='Count'">
                                {{ reportTotalRow['Paginated_'+col.field] | customNumberFormat:maximumFractionDigits | currencySymbol: null : col?.currencySymbol  }}
                            </ng-container>
                            <ng-container *ngIf="col.dataType=='number' && groupBySavedResults?.aggregationType!='Count'">
                                <span *ngIf="(reportTotalRow['Paginated_'+col.field] || reportTotalRow['Paginated_'+col.field]==0) && (col?.header=='Probability' || col?.header=='Rep Confidence' || col?.formControlType=='Percentage')">
                                    {{ reportTotalRow['Paginated_'+col.field] | numberToFixed }}%
                                </span>
                                <span *ngIf="col?.header!='Probability' && col?.header!='Rep Confidence' && col?.formControlType!='Percentage'">
                                    {{ reportTotalRow['Paginated_'+col.field] | numberToFixed }}
                                </span>
                            </ng-container>
                        </td>
                    </ng-container>
                </tr>
                <tr *ngIf="fromGroupBy || groupByParams?.aggregatedFields?.length>0">
                    <td>
                        <strong>{{groupBySavedResults?.aggregationType=='Sum'?'Grand_TOTAL':(groupBySavedResults?.aggregationType?
                            'Grand_'+groupBySavedResults?.aggregationType: ""
                            )}}</strong>
                        <span *ngIf="groupBySavedResults?.aggregationType=='Count'" class="p-ml-1">
                            ({{reportTotalRow[groupByParams?.groupBy?.columnName]||reportTotalRow['Aggregated_GroupNameCount']}})
                        </span>
                    </td>
                    <td *ngIf="groupByParams?.subGroupBy?.columnName"></td>
                    <ng-container *ngFor="let col of columns; let i=index;">
                        <td *ngIf="(groupByParams?.groupBy?.columnName && col.field!=groupByParams?.groupBy?.columnName && col.field!=groupByParams?.subGroupBy?.columnName) || (!fromGroupBy && i!=0)">
                            <ng-container *ngIf="col.dataType=='currency' && groupBySavedResults?.aggregationType!='Count'">
                                {{ reportTotalRow[col.field] | customNumberFormat:maximumFractionDigits | currencySymbol: null : col?.currencySymbol }}
                            </ng-container>
                            <ng-container *ngIf="col.dataType=='number' && groupBySavedResults?.aggregationType!='Count'">
                                <span
                                    *ngIf="(reportTotalRow[col.field] || reportTotalRow[col.field]==0)&& (col?.header=='Probability' || col?.header=='Rep Confidence' || col?.formControlType=='Percentage')">
                                    {{ reportTotalRow[col.field] | numberToFixed }}%
                                </span>
                                <span *ngIf="col?.header!='Probability' && col?.header!='Rep Confidence' && col?.formControlType!='Percentage'">
                                    {{ reportTotalRow[col.field] | numberToFixed }}
                                </span>
                            </ng-container>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="18">{{noData}}</td>
                </tr>
            </ng-template>
        </p-table>


        <ng-template let-s let-columns="columns" #groupColumns>
            <ng-container *ngFor="let col of columns">
                <td *ngIf="col?.isShow == true && col.field!=groupByParams?.groupBy?.columnName && col.field!=groupByParams?.subGroupBy?.columnName"
                        [ngClass]="{'normal-text': col?.dataType !== 'currency', 'currency-text': col?.dataType === 'currency'}">
                    <ng-container [ngSwitch]="col?.dataType">
                        <ng-container *ngSwitchCase="'date'">
                            <ng-container *ngIf="s[col.field] && col?.isDateWithTime">
                                {{ col?.isCustom ? (s[col.field] | localDate:'dateTime':false): (s[col.field] | localDate:'MM/DD/YYYY') }}
                            </ng-container>
                            <ng-container *ngIf="s[col.field] && !col?.isDateWithTime">
                                {{ s[col.field] | date:'MM/dd/yyyy' }}
                            </ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="'time'">
                            {{ s[col.field] | onlyTime }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'number'">
                            <span *ngIf="(col?.header=='Probability' || col?.header=='Rep Confidence' || col?.formControlType=='Percentage')">
                                {{ (s[col.field] || s[col.field]==0) ? s[col.field]+'%' : '' }}
                            </span>
                            <span *ngIf="col?.header!='Probability' && col?.header!='Rep Confidence' && col?.formControlType!='Percentage'">{{ s[col.field] }}</span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'currency'">
                            {{ s[col.field] | customNumberFormat:maximumFractionDigits | currencySymbol: null : col?.currencySymbol }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <span style="word-break: break-word;"
                                *ngIf="hiperLinkFields.includes(col?.fieldNameDB?.toLowerCase())"
                                class="saved-search-popup-link" (click)="onRouteNavigation(s, col)">
                                {{ s[col.field] }}
                            </span>
                            <a *ngIf="col?.formControlType=='URL'" [pTooltip]="s[col.field]" href="{{s[col.field] | url}}" target="_blank">{{ s[col.field] | shorten }}</a>
                            <span *ngIf="col?.formControlType=='EncryptedText'">
                                {{ s[col.field] ? '******' : ''}}
                            </span>
                            <span *ngIf="!hiperLinkFields.includes(col?.fieldNameDB?.toLowerCase()) && !['URL','EncryptedText'].includes(col?.formControlType)"
                                style="word-break: break-word;" [pTooltip]="(s[col.field] | removeHtmlTags)">
                                {{ (s[col.field] | removeHtmlTags | shorten:50)  }}
                            </span>
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>

        </ng-template>
    </div>

</ng-container>

<!-- Column Settings -->
    <p-dialog header="Column Settings" [(visible)]="displayColSetting" [style]="{width: '550px'}" [modal]="true"
    [baseZIndex]="10000">
    <div class="card">
        <div class="p-d-flex">
            <div>
                <h6>Column Selection (Max 30)/{{totalAmt}}</h6>
            </div>
        </div>
        <div>
            <input type="text" class="inputStyle p-inputtext" pInputText placeholder="Search for fields"
                [(ngModel)]="colSettingSearchInput">
        </div>
        <div class="p-d-flex p-ai-center gap-1 p-mt-2 ml-custom">
            <p-checkbox 
                    binary="true"
                    inputId="binary"
                    class="p-mr-2"
                    [(ngModel)]="selectAllSectionsFields"
                    (onChange)="enableAllSectionFields($event,selectedSearch?.savedSearchColumnSetting)">
            </p-checkbox>
            <label for="binary"><strong>Select All Fields</strong></label>
        </div>
        <div cdkDropList [cdkDropListData]="selectedSearch?.savedSearchColumnSetting"
            (cdkDropListDropped)="dropListCol($event)">
            <ng-container *ngFor="let module of selectedSearch?.savedSearchColumnSetting; let idx = index">
                <div *ngIf="(module.fields | gblFilter: colSettingSearchInput: 'labelName':'nestedFields')?.length>0" class="colList" cdkDrag (cdkDragStarted)="cdkDragStarted()" (cdkDragReleased)="cdkDragReleased()">
                    <hr style="margin: 0 0 0.5rem;">
                    <div class="section-header">
                        <h6 class="sectionLabel">
                            <span (click)="toggleChilds(module); $event.stopPropagation()">
                                <i class="pi p-mr-3" [ngClass]="{'pi-minus': (!module?.hideChilds || colSettingSearchInput),'pi-plus': !(!module?.hideChilds || colSettingSearchInput)}">
                                </i>
                            </span>
                            <!-- Move checkbox outside the toggle click area -->
                            <span (click)="$event.stopPropagation()">
                                <p-checkbox type="checkbox" binary="true" inputId="binary" class="p-mr-1" style="margin-left: -4px;"
                                     (onChange)="enableSectionFields($event, module,idx)" [disabled]="selectAllSectionsFields">
                                </p-checkbox>
                            </span>
                            <span (click)="toggleChilds(module); $event.stopPropagation()">
                                {{module.mapObject}}
                            </span>
                        </h6>
                    </div>
                    <div *cdkDragPreview>
                        <h6 class="moduleLabel p-pl-3" style="min-width: 200px;">{{module.mapObject}}</h6>
                    </div>
                    <div *ngIf="!module?.hideChilds || colSettingSearchInput" class="sub-columns" cdkDropList [cdkDropListData]="module.fields"
                        (cdkDropListDropped)="dropCol($event)">
                        <ng-container
                            *ngFor="let col of module.fields | gblFilter: colSettingSearchInput:'labelName':'nestedFields'; let i = index">
                            <div class="colList" cdkDrag appendTo="body">
                                <div class="p-d-flex">
                                    <i class="fa fa-bars p-mt-1 p-mr-2"
                                        [style.color]="!col.moveable ? 'lightgray' : 'var(--primary-color)' "></i>
                                    <p-checkbox *ngIf="!(col.nestedFields?.length > 0)" [disabled]="col.name == 'Task Id'" [(ngModel)]="col.isSelected"
                                        type="checkbox" binary="true" inputId="binary"
                                        (onChange)="onCheckChange($event.checked, col, null)" class="p-mr-2" [disabled]="(!col.isSelected && totalAmt >= 30) || ((col?.fieldName == 'BusinessName' || col?.fieldName == 'Name' || col?.fieldName == 'ItemNo' || col?.fieldName == 'Number') && col.isSelected) || setColumnFlag(col) ||
                                        col.fieldName==groupByParams?.groupBy?.labelName">
                                    </p-checkbox>
                                    <span class="p-mt-1">{{col.labelName}}</span>
                                    <button type="button" pButton pRipple
                                        class="p-button-text p-button-rounded p-button-plain p-ml-2"
                                        [icon]="col.nestedFields?.length > 0 && col?.showChildrens ? 'pi pi-minus' : 'pi pi-plus'"
                                        *ngIf="col.nestedFields?.length > 0" (click)="showChild(col)"
                                        style="height: 20px; width: 20px;">
                                    </button>
                                </div>
                                <div *ngIf="col?.nestedFields?.length > 0 && (col.showChildrens || (colSettingSearchInput && (col.nestedFields | gblFilter: colSettingSearchInput:'labelName':'nestedFields')?.length>0))">
                                    <ul>
                                        <li *ngFor="let childCol of col.nestedFields">
                                            <p-checkbox [(ngModel)]="childCol.isSelected" type="checkbox" binary="true"
                                                inputId="binary"
                                                (onChange)="onCheckChange($event.checked, col, col.nestedFields)"
                                                class="p-mr-2" [disabled]="(!childCol.isSelected && totalAmt >= 30) || setColumnFlag(childCol) ||
                                                groupzByParams?.groupBy?.labelName==col.labelName">
                                            </p-checkbox>
                                            {{childCol.labelName}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="onCancelColumnSettingsPopUp()" label="Cancel"
            class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="updateColumnSettings()"></button>
    </p-footer>
</p-dialog>
 

<app-column-settings-modal-for-rules [displayColumnSettings]="displayColumnSettings"
    [moduleName]="selectedSearch?.moduleName" [settingsObj]="columnSettingsN" [disabledLabelNames]="disabledLabelNames"
    [selectedView]="'list'" [maxColumn]="30" [channelId]="selectedSearch?.channelId"
    (savedColumnSettings)="savedColumnSettings($event)" (cancelColumnSettings)="cancelColumnSettings()">
</app-column-settings-modal-for-rules>

<!-- Account Edit Component -->
<app-edit-account *ngIf="displayAccountViewEdit"
    [displayEditViewDialog]="displayAccountViewEdit"
    [displayView]="true"
    [selectedAccountId]="selectedAccountId"
    (getAccountListAfterEdit)="reloadResultAfterSave()" (closeModal)="closeAccountViewEditModal()">
</app-edit-account>

<!-- Lead View/Edit -->
<app-add-update-view-lead *ngIf="displayLeadViewEdit" [display]="true"
    [selectedLeadId]="selectedLeadId"
    [selectedChannelId]="selectedSearch?.templateId"
    [crudType]="'view'" (cancelClicked)="closeLeadViewEdit()"
    (onComplete)="reloadResultAfterSave()">
</app-add-update-view-lead>

<!-- Opportunity View/Edit -->
<app-opportunity-add-edit-dialog *ngIf="displayOpportunityViewEdit" [displayAddEditDialog]="displayOpportunityViewEdit"
    [opportunityChannelId]="selectedSearch?.templateId"
    [accountChannelId]="selectedAccountChannelId"
    [opportunityId]="opportunityEditViewId" [crudType]="'view'"
    (reloadList)="reloadResultAfterSave($event)"
    (closeModal)="closeOpportunityViewEdit()">
</app-opportunity-add-edit-dialog>

<!-- Inventory Overview -->
<app-inventory-module-overview-dialogs
    *ngIf="displayInventoryOverview"
    [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId"
    [overviewRefNumber]="inventoryOverviewRefNumber"
    [overviewModule]="inventoryOverviewModule"
    (onCancel)="closeViewPopup()">
</app-inventory-module-overview-dialogs>

<app-vendor-view-edit *ngIf="displayVendorOverview"  [selectedVendor]="selectedVendorDetails"
     (closeDialog)="closeVendorView($event)">
</app-vendor-view-edit>


<p-dialog header="Export Confirmation" [(visible)]="displayExportDialog" [style]="{width: '380px'}" [modal]="true">
    <div class="p-d-flex">
        <i class="pi pi-info-circle"></i>
        <span class="p-ml-2">Do you want to export this Saved Search?</span>
    </div>
    <p-footer>
        <button type="button" pButton icon="pi pi-external-link" label="Open" (click)="downloadSavedSearch('open')"></button>
        <button type="button" pButton icon="pi pi-file-pdf" label="PDF" (click)="downloadSavedSearch('pdf')"></button>
        <button type="button" pButton icon="pi pi-file-excel" label="CSV" (click)="downloadSavedSearch('csv')"></button>
        <button type="button" pButton icon="pi pi-file-excel" label="XLSX" (click)="downloadSavedSearch('xlsx')"></button>
    </p-footer>
</p-dialog>
